<template>
    <b-row class="sell-cards">
        <b-col class="d-flex">
            <b-card-group
                class="mx-auto"
                deck
            >
                <sell-card
                    class="my-2"
                    v-for="(card, index) in cards"
                    :key="index"
                    :card="card"
                />
            </b-card-group>
        </b-col>
    </b-row>
</template>

<script>
    import './SellCards.scss';
    import './SellCards.tablet.scss';
    import LandingPageSellSectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageSellSectionAppResource";
    import SellCard from "./SellCard/SellCard";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

    export default {
        name: "SellCards",

        components: {SellCard},

        mixins: [IsMobileMixin],

        props: {
            sell: {
                type: LandingPageSellSectionAppResource,
                required: true,
            },

            cards: {
                type: Array,
                required: true,
            },
        },
    };
</script>
